module.exports = __webpack_public_path__ + "img/generic-success.22f91893.png";